import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { costingTabInfo } from 'features/costing/utils';

import { setActiveTabInfo } from '@store/actions/CostingAction';
import { clearGlobalFilter } from '@store/actions/FilterAction';

const InnerTabsForBuyerDesign = () => {
	const activeTabInfo = useSelector((store) => store.costingStore.activeTabInfo);
	const dispatch = useDispatch();

	const handleTabClick = (tabKey) => {
		dispatch(setActiveTabInfo(costingTabInfo[tabKey]));
		dispatch(clearGlobalFilter());
	};

	return (
		<div>
			<ul>
				<li
					className={`${activeTabInfo?.activeTabName === 'BUYER_DESIGN_PENDING' ? 'active' : ''}`}
					onClick={() => handleTabClick('BUYER_DESIGN_PENDING')}
				>
					Pending
				</li>
				<li
					className={`${activeTabInfo?.activeTabName === 'BUYER_DESIGN_COMPLETED' ? 'active' : ''}`}
					onClick={() => handleTabClick('BUYER_DESIGN_COMPLETED')}
				>
					Completed
				</li>
				<li
					className={`${activeTabInfo?.activeTabName === 'BUYER_DESIGN_ARCHIVE' ? 'active' : ''}`}
					onClick={() => handleTabClick('BUYER_DESIGN_ARCHIVE')}
				>
					Archive
				</li>
			</ul>
		</div>
	);
};

export default InnerTabsForBuyerDesign;
